import { Box, Typography } from "@mui/material";
import { flownectColors } from "@components/jobs2/jobs-calendar/const";
import { formatDate } from "../../../../../../../../utils";
import { formatElapsed, resolveWorkerStatus } from "../utils/EventJobModal.utils";

export const WorkerCard = ({ worker, baseColor, companyTimeZone, now, compact }) => {
    const alias = `${worker?.firstName ?? ""} ${worker?.lastName ?? ""}`.trim();
    const role = worker?.WorkforcesByJobs?.jobWorkforceRole ?? "employee";

    const workforceEvent = worker?.WorkforcesByJobEvents || {};
    const { isCompleted, isInProgress } = resolveWorkerStatus(workforceEvent);
    const { startAt, endAt } = workforceEvent;

    const elapsedSeconds =
        isInProgress && startAt
            ? Math.max(0, Math.floor((now - new Date(startAt).getTime()) / 1000))
            : 0;

    return (
        <Box
            sx={{
                minWidth: compact ? "fit-content" : 140,
                maxWidth: compact ? "100%" : undefined,
                px: compact ? 1 : 1.5,
                py: compact ? 0.65 : 1.5,
                borderRadius: 1.5,
                bgcolor: "var(--fx-surface-base, #FFFFFF)",
                border: "none",
                display: "flex",
                flexDirection: "column",
                alignItems: compact ? "flex-start" : "center",
                gap: 0.35,
                textAlign: compact ? "left" : "center",
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    color: flownectColors.gray[600],
                    textTransform: "capitalize",
                    fontSize: compact ? 10.5 : "0.65rem",
                    lineHeight: 1.1,
                }}
            >
                {role}
            </Typography>

            <Typography
                variant="body2"
                noWrap
                sx={{
                    fontWeight: 400,
                    color: flownectColors.gray[800],
                    lineHeight: 1.2,
                    fontSize: compact ? 12 : "0.7rem",
                }}
            >
                {alias}
            </Typography>

            {isInProgress && startAt && (
                <Typography
                    variant="caption"
                    sx={{
                        mt: 0.15,
                        color: baseColor,
                        fontWeight: 400,
                        fontSize: compact ? "0.68rem" : "0.62rem",
                        lineHeight: 1.25,
                        fontVariantNumeric: "tabular-nums",
                    }}
                >
                    {formatElapsed(elapsedSeconds)}
                </Typography>
            )}

            {isCompleted && startAt && endAt && (
                <Box sx={{ mt: 0.15 }}>
                    {[
                        { label: "Start", value: startAt },
                        { label: "Finish", value: endAt },
                    ].map(({ label, value }) => (
                        <Typography
                            key={label}
                            variant="caption"
                            sx={{
                                display: "block",
                                color: flownectColors.gray[700],
                                fontWeight: 400,
                                fontSize: compact ? "0.68rem" : "0.62rem",
                                lineHeight: 1.25,
                            }}
                        >
                            {label} {formatDate(value, companyTimeZone, "h:mm a")}
                        </Typography>
                    ))}
                </Box>
            )}
        </Box>
    );
};
